import React from 'preact/compat';
import { h } from 'preact';
import { Checkbox } from 'list/DesignSystem';
import { List } from 'adapters/list/graphqlTypes';
import { PREFIX } from 'list/DesignSystem/constants';
import translate from 'list/utils/translate';
import './lists.scss';

type ListProps = {
    lists: List[];
    onChange: (listId: string, name: string, checked: boolean) => void;
};

const CompactLists = ({ lists, onChange }: ListProps) => {
    return (
        <ul className={`${PREFIX}selectable-lists`}>
            {lists.map(({ listId, retail: { items }, name }) => {
                const image =
                    items[items.length - 1]?.product?.images?.find(({ quality }) => quality === 'S3')?.url ?? ' ';
                return (
                    <li className="list" key={listId}>
                        <img className="list-image" src={image} alt="" />
                        <div className="list-name">{name || translate('Default list name')}</div>
                        <div className="checkbox">
                            <Checkbox
                                data-testid={`${listId}_checkbox`}
                                onChange={(e: any) => onChange(listId, name, e.target.checked)}
                                id={`select-${listId}`}
                            />
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

export default CompactLists;
